/**
 * 記事のリンクが行き先なので、外部サイトのhttp(s)は許可する。
 * `javascript:` などはスクリプトとして実行されるため、http(s)以外は許可しない。
 */
export const toSafeRedirectUrl = (url: string): string | null => {
  try {
    const parsed = new URL(url, window.location.origin);
    return ['http:', 'https:'].includes(parsed.protocol) ? parsed.href : null;
  } catch {
    return null;
  }
};

/**
 * パスやクエリにホスト名が含まれるだけの外部サイトを同じホストとして扱わないよう、`includes` は使わない。
 */
export const isCurrentHostUrl = (url: string): boolean => {
  try {
    return new URL(url, window.location.origin).host === window.location.host;
  } catch {
    return false;
  }
};
